/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { invoiceNew } from '@/api/ajax';
import { makeTableRenderOptionsByMap } from '@/tools';
import {
  STATUS_INVOICE,
  PROFESSION_TYPE,
  OFFLINE_STATUS_INVOICE,
  ORDER_MIXTURE_TYPE
} from './fields';
import { bankSearchFiled } from '@/common/fields/bank';
import { ORDER_BILL_TYPE } from '@/common/constants/order';

export default [
  {
    width: 180,
    tip: '请输入供应商名称',
    key: 'companyName',
    id: 'companyName',
    slot: 'input'
  },
  {
    width: 180,
    tip: '请输入支付对象',
    key: 'companyName',
    id: 'paymentObject',
    slot: 'input'
  },
  {
    width: 180,
    tip: '请输入订单编号',
    key: 'orderNo',
    id: 'orderNo',
    slot: 'input'
  },
  {
    width: 180,
    tip: '请输入项目名称',
    key: 'projectName',
    id: 'projectName',
    slot: 'input'
  },
  {
    width: 180,
    tip: '开票类目',
    key: 'itemName',
    id: 'itemName',
    slot: 'input'
  },
  {
    width: 180,
    id: 'daterange',
    tip: '申请时间',
    // key: 'daterange',
    required: false,
    slot: 'daterange',
    format: 'yyyy-MM-dd',
    rangeValue: [],
    key: ['createStartDt', 'createEndDt'],
    text: ['申请时间始', '申请时间止']
  },
  {
    width: 180,
    id: 'authDaterange',
    tip: '提交申请时间',
    // key: 'authDaterange',
    required: false,
    slot: 'daterange',
    format: 'yyyy-MM-dd',
    rangeValue: [],
    key: ['authStartDt', 'authEndDt'],
    text: ['提交时间始', '提交时间止']
  },
  {
    width: 180,
    id: 'kaipiaoshijian',
    tip: '开票时间',
    // key: 'authDaterange',
    required: false,
    slot: 'daterange',
    format: 'yyyy-MM-dd',
    rangeValue: [],
    key: ['authStartDt', 'authEndDt'],
    text: ['开票时间起', '开票时间止']
  },
  // 待开票订单
  {
    width: 180,
    tip: '请选择订单类型',
    key: 'invoiceOrderType',
    id: 'daikaipiaodingdanType',
    slot: 'select',
    clearable: true,

    options: Object.values(ORDER_BILL_TYPE)
      .filter(item => item.value !== 3) // 不要3类型
      .map(item => {
        return {
          name: item.label,
          key: item.value
        };
      })
  },

  {
    width: 180,
    tip: '请选择订单类型',
    key: 'orderType',
    id: 'invoiceOrderType',
    slot: 'select',
    clearable: true,
    options: [
      {
        name: '支付订单',
        key: 1
      },
      {
        name: '综合服务费',
        key: 2
      }
    ]
  },
  {
    width: 180,
    tip: '开票状态',
    key: 'invoiceStatus',
    id: 'invoiceStatus',
    slot: 'select',
    clearable: true,
    options: makeTableRenderOptionsByMap(STATUS_INVOICE)
  },
  {
    width: 180,
    tip: '销售方',
    key: 'enterpriseName',
    id: 'invoicingSupplier',
    slot: 'input'
  },
  {
    width: 180,
    tip: '交易结构',
    key: 'professionType',
    id: 'professionType',
    slot: 'select',
    clearable: true,
    options: makeTableRenderOptionsByMap(PROFESSION_TYPE)
  },
  {
    width: 180,
    tip: '订单类型',
    key: 'orderMixtureType',
    id: 'orderMixtureType',
    slot: 'select',
    clearable: true,
    options: makeTableRenderOptionsByMap(ORDER_MIXTURE_TYPE)
  },
  {
    width: 180,
    tip: '发票类目',
    key: 'itemName',
    id: 'invoiceCategory',
    slot: 'input'
  },
  {
    width: 220,
    tip: '发票申请编号',
    key: 'id',
    id: 'id',
    slot: 'input'
  },
  {
    id: 'jiesuangongyingshang',
    key: 'enterpriseName',
    tip: '请输入客户企业',
    slot: 'ajaxSelect',
    ajax: invoiceNew.listSelectEnterprise,
    prop: {
      label: 'enterpriseName',
      code: 'enterpriseName'
    },
    ajaxQuery: 'keyWord',
    width: '180'
  },
  {
    width: 180,
    tip: '开票状态',
    key: 'status',
    id: 'offlineInvoiceStatus',
    slot: 'select',
    clearable: true,
    options: makeTableRenderOptionsByMap(OFFLINE_STATUS_INVOICE)
  },
  bankSearchFiled
];
